module.exports = __webpack_public_path__ + "static/media/lets_get_started.f1552a06.svg";